import Grid from "@/components/Grid";
import ReportListCard from "@/components/ReportListCard";
import { AvailableBadge, ComingSoonBadge, UnreleasedBadge } from "@/components/reports/Badges";
import { getCustomerReportClickDisabled } from "@/components/reports/reportListClick";
import { COMING_SOON } from "@/core/constants";
import { PanelBoxV2 } from "@/tpo/Boxes";
import { useQuery } from "@apollo/client";
import { useTheme } from "styled-components";

export default function ReportsGrid({
  query,
  skipQuery,
  queryVariables = {},
  listName = "reports",
  onReportClick
}) {
  const theme = useTheme();

  const { data: reportsData } = useQuery(query, {
    variables: {
      ...queryVariables
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip: skipQuery
  });
  const reports = reportsData?.[listName];

  return (
    <PanelBoxV2
      maxWidth={1280}
      outer={{
        bg: "haze",
        pt: theme.spacing.section.pt,
        pb: theme.spacing.section.pb,
        px: [16, 16, "5.5vw"]
      }}
    >
      <Grid
        gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)", "repeat(2, 1fr)"]}
        gap={16}
        gridColumnGap={16}
      >
        {reports?.map(report => {
          const isComingSoon = report?.purchaseProduct?.status === COMING_SOON;
          const clickDisabled = getCustomerReportClickDisabled({ report });

          let topRightButton = null;
          if (isComingSoon) {
            topRightButton = <ComingSoonBadge />;
          } else if (!report.isAvailable) {
            topRightButton = <UnreleasedBadge />;
          } else if (report.isAvailable) {
            topRightButton = <AvailableBadge />;
          }

          const userReport = reportsData?.userReports?.find(
            userReport => userReport.subsector.id == report.id
          );
          const userReportFunctionalDatapointCount =
            (userReport?.functionalDatapointCounts?.inRangeCount || 0) +
            (userReport?.functionalDatapointCounts?.outOfRangeCount || 0);
          const userReportDnaDatapointCount =
            (userReport?.dnaDatapointCounts?.inRangeCount || 0) +
            (userReport?.dnaDatapointCounts?.outOfRangeCount || 0);
          const userReportSymptomsCount =
            (userReport?.questionsAndAnswersCounts?.inRangeCount || 0) +
            (userReport?.questionsAndAnswersCounts?.outOfRangeCount || 0);

          const totalFunctionalDatapointCount = report?.functionalDatapointCount || 0;
          const totalDnaDatapointCount = report?.dnaDatapointCount || 0;
          const totalSymptomsCount = report?.questionsAndAnswersCount || 0;

          return (
            <ReportListCard
              key={report.id}
              id={report.id}
              name={report.name}
              shortDescription={report?.purchaseProduct?.content?.shortDescription}
              iconType={report?.purchaseProduct?.content?.reportIcon}
              iconSize={[40, 40, 80]}
              onClick={() => {
                if (clickDisabled) return;
                onReportClick?.(report);
              }}
              functionalDatapointCount={totalFunctionalDatapointCount}
              userReportFunctionalDatapointCount={userReportFunctionalDatapointCount}
              dnaDatapointCount={totalDnaDatapointCount}
              userReportDnaDatapointCount={userReportDnaDatapointCount}
              symptomsCount={totalSymptomsCount}
              userReportSymptomsCount={userReportSymptomsCount}
              variant={isComingSoon ? "disabled" : "active"}
              topRightButton={topRightButton}
            />
          );
        })}
      </Grid>
    </PanelBoxV2>
  );
}
